// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import { store } from "./store";
import { Axios } from "./axios";

import BootstrapVue from "bootstrap-vue";

Vue.use(BootstrapVue);

Vue.config.productionTip = false;

Vue.mixin({
	methods: {
		imgToStaticPath: function(path = "") {
			return (
				process.env.VUE_APP_STATIC_PATH_PREFIX.replace(/\/?$/, "/") +
				"static/img/" +
				path
			);
		},
		validEmail: function(email) {
			return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
				email
			);
		},
		returnHome: function() {
			this.$store.dispatch("resetData");
			this.$router.push("/");
		}
	}
});

// Register a global custom directive called `v-focus`
Vue.directive("focus", {
	// When the bound element is inserted into the DOM...
	inserted: function(el) {
		// Focus the element
		el.focus();
	}
});

Vue.prototype.$axios = Axios;

/* eslint-disable no-new */
new Vue({
	store,
	router,
	render: h => h(App)
}).$mount("#app");
